import { defineStore } from "pinia";
import type { CustomerVo, ShowAuthEquityGuide } from "@zhihaoscm/entity";
import { ROLE_CODE } from "@zhihaoscm/meta";
import { deleteCookie } from "@/utils";
// import localUser from "./localUser";
import sensors from "sa-sdk-javascript";

interface IStoreProps {
    userInfo: CustomerVo;
    zhihaoWebToken: string;
    // token: string;
    mobile: string;
    isOldUser: number;
    roleCode?: number;
    proxyAccountId?: number;
    // 未读消息
    allUnreadMsgNum: number;
    /* 绑定时间 */
    bindTime: string;
    /* 微信昵称 */
    nickName: string;
    /* 电子签章授权状态 */
    authorizationState?: number;
    /* 已阅读数据看板指引用户列表 */
    isReadDashboardGuideList: number[];
    /* 密码修改时间**/
    passwordUpdateTime: string;
    /* 邮箱**/
    email: string;
    /* 展示企业认证引导，区分不同身份**/
    isShowAuthEquityGuideList: ShowAuthEquityGuide[];
}

export const useUserStore = defineStore("zhihao-web-user", {
    state: (): IStoreProps => {
        // if (window.location.hostname === "localhost" || window.location.protocol === "http:") {
        //     localStorage.setItem("zhihao-web-user", JSON.stringify(localUser));
        //     Reflect.deleteProperty(localUser, "token");
        //     return localUser as IStoreProps;
        // } else {
        const zhihaoWebUserObj = JSON.parse(window.localStorage.getItem("zhihao-web-user") || "{}");

        return {
            zhihaoWebToken: zhihaoWebUserObj?.zhihaoWebToken || "",
            // token: zhihaoWebUserObj?.zhihaoWebToken ||  "",
            userInfo: zhihaoWebUserObj.userInfo || ({ customer: {} } as CustomerVo),
            mobile: zhihaoWebUserObj.mobile || "",
            isOldUser: zhihaoWebUserObj.isOldUser || (undefined as unknown as number),
            roleCode: zhihaoWebUserObj.roleCode || (undefined as unknown as number),
            proxyAccountId: zhihaoWebUserObj.proxyAccountId || (undefined as unknown as number),
            allUnreadMsgNum: zhihaoWebUserObj.allUnreadMsgNum || 0,
            bindTime: zhihaoWebUserObj.bindTime || "",
            nickName: zhihaoWebUserObj.nickName || "",
            authorizationState: zhihaoWebUserObj.authorizationState || (undefined as unknown as number),
            isReadDashboardGuideList: zhihaoWebUserObj.isReadDashboardGuideList || [],
            passwordUpdateTime: "",
            email: "",
            isShowAuthEquityGuideList: [] as ShowAuthEquityGuide[]
        };
        // }
    },
    getters: {
        token: state => {
            return state.zhihaoWebToken;
        },
        customerId: state => {
            return state.userInfo.customer.id;
        },
        isCustomer: state => {
            return state.roleCode === ROLE_CODE.CUSTOMER.code;
        },
        isSupplier: state => {
            return state.roleCode === ROLE_CODE.SUPPLIER.code;
        },
        isSupplyChain: state => {
            return state.roleCode === ROLE_CODE.SUPPLY_CHAIN.code;
        },
        isCertified: state => {
            return Boolean(state.userInfo.customer.realName || state.userInfo.customer.institutionName);
        },
        memberInfo: state => {
            return {
                memberLevel: state.userInfo.customer?.memberLevel,
                memberExpiryDate: state.userInfo.customer?.memberExpiryDate,
                memberActiveTime: state.userInfo.customer?.memberActiveTime,
                memberState: state.userInfo.customer?.memberState,
                memberPermission: state.userInfo.memberPermission
            };
        }
    },
    actions: {
        setToken(token: string) {
            this.zhihaoWebToken = token;
        },
        setMobile(mobile: string) {
            this.mobile = mobile;
        },
        setUserInfo(userInfo: any) {
            this.userInfo = userInfo as unknown as CustomerVo;
            sensors?.registerPage({
                customer_id: userInfo?.customer?.id
            });
        },
        setRoleCode(roleCode: number) {
            this.roleCode = roleCode;
        },
        /** 设置绑定时间 */
        setBindTime(bindTime: string) {
            this.bindTime = bindTime;
        },
        /** 设置微信昵称 */
        setNickName(nickName: string) {
            this.nickName = nickName;
        },
        /** 设置电子签章授权状态 */
        setAuthorizationState(authorizationState: number) {
            this.authorizationState = authorizationState;
        },
        setProxyAccountId(proxyAccountId: number) {
            this.proxyAccountId = proxyAccountId;
        },
        setIsOldUser(isOldUser: number) {
            this.isOldUser = isOldUser;
        },
        setAllUnreadMsgNum(num: number) {
            this.allUnreadMsgNum = num;
        },
        /** 设置是否已阅读数据看板指引 */
        setIsReadDashboardGuide(userId: number) {
            this.isReadDashboardGuideList.push(userId);
        },
        clear() {
            // 清除cookie 中的 zhihaoWebToken
            deleteCookie("zhihao-web-token-new");
            this.zhihaoWebToken = "";
            this.userInfo = { customer: {} } as CustomerVo;
            this.allUnreadMsgNum = 0;
            this.bindTime = "";
            this.nickName = "";
            this.authorizationState = 0;
            localStorage.removeItem('location');
        },
        /* 设置密码修改时间**/
        setPasswordUpdateTime(time: string) {
            this.passwordUpdateTime = time;
        },
        /* 设置邮箱**/
        setEmail(email: string) {
            this.email = email;
        },
        /** 设置是否展示企业认证引导 */
        setIShowAuthEquityGuideList(isShow: boolean) {
            const item: ShowAuthEquityGuide | undefined = this.isShowAuthEquityGuideList.find(
                item => item.role === this.roleCode
            );
            if (!item) {
                this.isShowAuthEquityGuideList.push({ role: this.roleCode, isShow });
            } else {
                item.isShow = isShow;
            }
        }
    },
    persist: true
});
